import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Boat Trips from Quarteira · Private Yacht · Morningstar";
const DESC =
  "Private boat trips from Quarteira aboard Morningstar — Marina de Vilamoura is 5 minutes away. Benagil cave tour, sunset cruise & Algarve day trips for up to 18 guests, crewed and catered.";
const PATH = "/boat-trips-quarteira";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/boat-trips-quarteira")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Boat Trips from Quarteira · Algarve",
        title: "Boat trips from Quarteira aboard ",
        titleAccent: "Morningstar.",
        sub: "Private yacht charters a 5-minute drive from Quarteira, from Marina de Vilamoura — Benagil caves, sunset cruises and Algarve day trips, crewed and catered.",
        ctaPrimary: "View cruises",
        ctaSecondary: "Plan my day",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "boat trips Quarteira, Quarteira boat hire, Quarteira yacht charter, Quarteira to Benagil, Algarve cruise from Quarteira",
      altPath: { en: PATH, pt: "/pt/passeios-de-barco-quarteira" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private boat trips from Quarteira",
              description: DESC,
              url: URL,
              itinerary: "Marina de Vilamoura (5 min from Quarteira) → Algarve coastline → cave & swim stop → return.",
              durationHours: 4,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Boat Trips from Quarteira", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});